import { SDLUtil, RequestUtil, StringUtil, DateUtil } from '@/utils';

const setGridData = ({ commit }, data) => {
  commit('SET_GRID_DATA_ACCKEY_DETAILS', data);
};

const setProjectList = ({ commit }, data) => {
  commit('SET_PROJECT_LIST_ACCKEY_DETAILS', data);
};
export default {
  async SEARCH_GRID_ACCKEY_DETAILS(store, param) {
    const searchPeriod = DateUtil.stdFormat(param.searchPeriod);
    param = { ...param, ...searchPeriod };
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accesskey/details/info-list?${StringUtil.queryStringfy(param)}`);

    setGridData(store, data.data);
  },
  async SEARCH_PROJECT_LIST_ACCKEY_DETAILS(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/accesskey/details/project?${StringUtil.queryStringfy(param)}`);

    setProjectList(store, data.data);
  },
  async UPDATE_EXCEPT_ACCKEY_DETAILS(store, param) {
    await RequestUtil.put(`${SDLUtil.API_URL}/accesskey/details/key-except`, param);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/accKey/details/accKeyDetailsAction.js